import { FC } from 'react';

import { Trash2 } from 'lucide-react';
import useSWRMutation from 'swr/mutation';

import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import { providerService } from 'v2/api/providerService';
import { Popconfirm } from 'v2/components/popconfirm/Popconfirm';
import { FreeSpinModel } from 'v2/types/FreeSpinModel';
import { handleHttpError } from 'v2/utils';

interface FreeSpinsTableActionsColumnProps {
  freeSpin: FreeSpinModel;
  onRevalidate: VoidFunction;
}

export const FreeSpinsTableActionsColumn: FC<FreeSpinsTableActionsColumnProps> = ({ freeSpin, onRevalidate }) => {
  const { trigger } = useSWRMutation(['deleteFreeSpins', freeSpin.id], providerService.deleteFreeSpins, {
    onSuccess: () => {
      onRevalidate();
    },
    onError: handleHttpError,
  });

  return (
    <Popconfirm message="Are you sure that you want to delete this free spins?" onConfirm={trigger}>
      <Tooltip title="Delete" placement="top">
        <IconButton color="error">
          <Trash2 width={22} height={22} />
        </IconButton>
      </Tooltip>
    </Popconfirm>
  );
};
